// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BEMmB","toggleWrap":"styles_toggleWrap__ADQ7Z","content":"styles_content__1_UJn","selectAreaCode":"styles_selectAreaCode__k9-_J"};